import React from "react";
import ConfirmDialog from "../../../../components/ConfirmDialog/ConfirmDialog";

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  accountLabel,
  loading,
}) => {
  const getHeading = () => {
    return `Removing Connection ${accountLabel ?? ""}`;
  };

  const getContent = () => {
    return `Are you sure you want to remove the connection? This might affect ongoing audits that are using this connection.`;
  };

  const getNote = () => {
    return `This will just remove the connection and not remove the data that has been used for audits.`;
  };

  const getButtonText = () => {
    if (loading) {
      return "Removing...";
    }
    return "Remove";
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      heading={getHeading()}
      content={getContent()}
      note={getNote()}
      buttonText={getButtonText()}
      loading={loading}
      maxWidth="md"
      minWidth={550}
      customMaxWidth={650}
    />
  );
};

export default DeleteConfirmationDialog;
